import { render, staticRenderFns } from "./mediaPublishAudioUpload.vue?vue&type=template&id=081f9a48&scoped=true&"
import script from "./mediaPublishAudioUpload.vue?vue&type=script&lang=js&"
export * from "./mediaPublishAudioUpload.vue?vue&type=script&lang=js&"
import style0 from "./mediaPublishAudioUpload.vue?vue&type=style&index=0&id=081f9a48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081f9a48",
  null
  
)

component.options.__file = "mediaPublishAudioUpload.vue"
export default component.exports